'use client';

import '@savvy-kit/components/button';

import { Checkbox } from '@savvy-kit/components/checkbox';
import { cn } from '@savvy-kit/lib/utils';

import type { CheckboxFilterValue } from '../../types/filter-values';
import { FilterActions } from './shared/filter-actions';

export type CheckboxFilterProps = {
  readonly value: CheckboxFilterValue | undefined;
  readonly onChange: (value: CheckboxFilterValue | undefined) => void;
  readonly className?: string;
};

export function CheckboxFilter({ value, onChange, className }: CheckboxFilterProps) {
  const isYesSelected = value?.operator === 'is' && value.value;
  const isNoSelected = value?.operator === 'is' && !value.value;

  return (
    <div className={cn('flex flex-col gap-4 p-3', className)}>
      <Checkbox
        checked={isYesSelected}
        onCheckedChange={(checked) => onChange(checked ? { operator: 'is', value: true } : undefined)}
        label="Yes"
      />
      <Checkbox
        checked={isNoSelected}
        onCheckedChange={(checked) => onChange(checked ? { operator: 'is', value: false } : undefined)}
        label="No"
      />
      {value && <FilterActions onClear={() => onChange(undefined)} />}
    </div>
  );
}
